const state = {
  databaseStore:
    [
      {
        id: 1,
        title_en: "Transact SQL",
        title_ua: "Transact SQL",
        title_es: "Transact SQL",
        regnumber: "TP71375264",
        grade: "909 / 1000",
        examdate: "26.01.2021",
        image: "https://testprovider.com/ru/search-certificate/tp71375264",
      },
      {
        id: 2,
        title_en: "MySQL",
        title_ua: "MySQL",
        title_es: "MySQL",
        regnumber: "TP99655661",
        grade: "1000 / 1000",
        examdate: "23.02.2021",
        image: "https://testprovider.com/ru/search-certificate/tp99655661",
      },
      {
        id: 3,
        title_en: "PostgreSQL",
        title_ua: "PostgreSQL",
        title_es: "PostgreSQL",
        regnumber: "TP84560502",
        grade: "1000 / 1000",
        examdate: "20.04.2021",
        image: "https://testprovider.com/ru/search-certificate/tp84560502",
      },
      {
        id: 4,
        title_en: "MongoDB",
        title_ua: "MongoDB",
        title_es: "MongoDB",
        regnumber: "TP56496721",
        grade: "1000 / 1000",
        examdate: "21.04.2021",
        image: "https://testprovider.com/ru/search-certificate/tp56496721",
      },
      {
        id: 5,
        title_en: "SQL Essential",
        title_ua: "SQL Базовий",
        title_es: "SQL Esencial",
        regnumber: "TP98353860",
        grade: "1000 / 1000",
        examdate: "18.06.2023",
        image: "https://testprovider.com/ru/search-certificate/tp98353860",
      },
      {
        id: 6,
        title_en: "MySQL Essential",
        title_ua: "MySQL Базовий",
        title_es: "MySQL Esencial",
        regnumber: "TP74028044",
        grade: "1000 / 1000",
        examdate: "01.07.2024",
        image: "https://testprovider.com/ru/search-certificate/tp74028044",
      },
    ]
};
const getters = {};
const mutations = {};
const actions = {};
export default {
  state,
  getters,
  mutations,
  actions
};